import { render, staticRenderFns } from "./Trabajos.vue?vue&type=template&id=db201dfc&scoped=true&"
import script from "./Trabajos.vue?vue&type=script&lang=js&"
export * from "./Trabajos.vue?vue&type=script&lang=js&"
import style0 from "./Trabajos.vue?vue&type=style&index=0&id=db201dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db201dfc",
  null
  
)

export default component.exports